import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import { dggTheme } from '../../../../styles/dggTheme';

const { fonts, spacing } = dggTheme;

export const sectionTitle = css`
  margin: ${pxToRem(spacing.xl)} ${pxToRem(spacing.md)};
  font-family: ${fonts.PRIMARY_SEMIBOLD.familyWithFallbacks};
  line-height: 37px;
  font-size: 35px;
`;
